"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var debounce = function debounce(fn, waitFor) {
  var timeout;

  var clear = function clear() {
    if (timeout != null) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  var debouncedFn = function debouncedFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clear();
    timeout = setTimeout(function () {
      fn.apply(void 0, args);
    }, waitFor);
  };

  debouncedFn.cancel = function () {
    clear();
  };

  return debouncedFn;
};

var _default = debounce;
exports.default = _default;